require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./truncatedtext"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./truncatedtext"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./truncatedtext")) : factory(root["./utils"], root["./svgicon"], root["./truncatedtext"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__17__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[76],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(619);


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.WizardStepIndicator = exports.WizardProgressIndicator = void 0;

var _WizardProgressIndicator = __webpack_require__(620);

exports.WizardProgressIndicator = _WizardProgressIndicator.WizardProgressIndicator;

var _WizardStepIndicator = __webpack_require__(623);

exports.WizardStepIndicator = _WizardStepIndicator.WizardStepIndicator;

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.WizardProgressIndicator = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

var _WizardProgressIndicator = _interopRequireDefault(__webpack_require__(621));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var _CLASS = _WizardProgressIndicator["default"].wizardProgressIndicatorClassName.replace(/"/g, '');

var INCOMPLETE = 'INCOMPLETE';
var CURRENT = 'CURRENT';
var COMPLETED = 'COMPLETED';
var STEPS = [COMPLETED, CURRENT, INCOMPLETE];

var WizardProgressIndicator = function WizardProgressIndicator(props) {
  var _indicatorProps$curre;

  var steps = props.steps,
      _props$dataTid = props['data-tid'],
      dataTid = _props$dataTid === void 0 ? _CLASS : _props$dataTid,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      indicatorProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["steps", "data-tid", "className"]);
  var classNames = (0, _utils.classnames)(_CLASS);
  var currentIndex = (_indicatorProps$curre = indicatorProps.currentIndex) != null ? _indicatorProps$curre : steps.findIndex(function (step) {
    return step.step === CURRENT;
  });
  var mappedSteps = steps.map(function (_ref) {
    var step = _ref.step,
        stepProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["step"]);
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.ProgressStep, stepProps);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames + " " + className,
    "data-tid": dataTid
  }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.ProgressIndicator, (0, _extends2["default"])({
    currentIndex: currentIndex
  }, indicatorProps), mappedSteps));
};

exports.WizardProgressIndicator = WizardProgressIndicator;
WizardProgressIndicator.propTypes = {
  /** currentIndex has the same effect as step.current (if both given they must match) */
  currentIndex: _propTypes["default"].number,
  steps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,

    /** step is deprecated: see the Carbon ProgressStep props */
    step: _propTypes["default"].oneOf(STEPS).isRequired,

    /** current has the same effect as currentIndex (if both given they must match) */
    current: _propTypes["default"].bool
  }))
};

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(622);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "\n", ""]);

// exports
exports.locals = {
	"wizardProgressIndicatorClassName": "\"ba-common-WizardProgressIndicator\""
};

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.WizardStepIndicator = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _checkmarkFilled_ = _interopRequireDefault(__webpack_require__(624));

var _current_ = _interopRequireDefault(__webpack_require__(625));

var _incomplete_ = _interopRequireDefault(__webpack_require__(626));

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _WizardStepIndicator = _interopRequireDefault(__webpack_require__(627));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var iconMap = {
  COMPLETED: _checkmarkFilled_["default"],
  CURRENT: _current_["default"],
  INCOMPLETE: _incomplete_["default"]
};

var WizardStepIndicator = function WizardStepIndicator(props) {
  var icon = iconMap[props.step] || iconMap.INCOMPLETE;

  var sanitizedClassName = _WizardStepIndicator["default"].wizardStepIndicatorClassName.replace(/"/g, '');

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: sanitizedClassName,
    "data-tid": "wizard-step-indicator"
  }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
    iconId: icon.id
  }), /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
    value: props.label
  }));
};

exports.WizardStepIndicator = WizardStepIndicator;
WizardStepIndicator.propTypes = {
  label: _propTypes["default"].string.isRequired,
  step: _propTypes["default"].string
};

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/checkmark--filled_16.js");

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/current_16.js");

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/incomplete_16.js");

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(628);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-wizard-step-indicator{align-items:center;display:flex;padding-right:16px;width:100%}.ba-common-wizard-step-indicator svg{fill:#1f57a4;margin-right:8px}.ba-common-wizard-step-indicator>div{display:inline}\n", ""]);

// exports
exports.locals = {
	"wizardStepIndicatorClassName": "\"ba-common-wizard-step-indicator\""
};

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[618,0]]]);
});